import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import booking from './modules/booking';
import skirental from './modules/ski/rental';
import skipass from './modules/ski/pass';
import skischool from './modules/ski/school';
import reminders from './modules/reminders';
import affiliates from './modules/affiliate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    nav,
    booking,
    skirental,
    skipass,
    skischool,
    reminders,
    affiliates,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js